import { OFFSET_LIMIT_100, TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FETCH_ORDERS,
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import { getRequest } from '../../Common/network-call';
import _ from 'lodash';

export const MY_BOOKED_SPEAKERS = 'MY_BOOKED_SPEAKERS';
export const FETCH_SPEAKERS = 'FETCH_SPEAKERS';
export const OPEN_SPEAKER_DETAILS = 'OPEN_SPEAKER_DETAILS';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';

export const fetchBookedSpeakers = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=speaker)`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?include_count=true&fields=${FIELDS.bookmarks.minInfo}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        let localArr = response.resource;
        _.map(localArr, speaker => {
          let firstName = !_.isEmpty(speaker?.firstname)
            ? speaker?.firstname.trim()
            : 'G';
          let lastName = !_.isEmpty(speaker?.lastname)
            ? speaker?.lastname.trim()
            : 'U';

          speaker.firstname = firstName;
          speaker.lastname = lastName;
        });
        dispatch({
          type: MY_BOOKED_SPEAKERS,
          payload: { resource: localArr, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: localArr,
          count: response.meta.count
        });
      },
      error => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchAllSpeakers = (session, middleWares, callback) => {
  // --- middleWares is a object that has all the surplus params
  let pageCount = middleWares?.pagecount ?? 0; // for offset calculation
  let actionType = middleWares?.type ?? ''; // ''/'search'/'redirection'
  let searchTerm = middleWares?.term ?? ''; // keyword to search
  let dataArr = middleWares?.data ?? []; // previous fetched collection to concat upon
  let reRender = middleWares?.rerender ?? false; // true if re-render of list is needed
  let selectedSpeakerId = middleWares?.id ?? null; // bookmarked / selected speaker id to filter
  let chunkDataArr =
    reRender && middleWares?.data?.length ? _.chunk(middleWares?.data, 20) : [];
  let bookmarkAction = middleWares?.action ?? ''; // bookmark/unmark/rerender

  // --- pagination handling
  let perPage = OFFSET_LIMIT_100;
  if (reRender && selectedSpeakerId && chunkDataArr.length) {
    _.map(chunkDataArr, (chunkItem, chunkIndex) => {
      let filterChunk = _.filter(
        chunkItem,
        spnItem => spnItem.sponsorid == selectedSpeakerId
      );

      if (filterChunk.length) pageCount = chunkIndex + 1;
    });
  }
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let offSetQuery = _.isNull(selectedSpeakerId)
    ? `&limit=${perPage}&offset=${offset}`
    : '';

  // --- param handling
  let fetchFilter = '',
    others = '';
  if (actionType == 'search') {
    // ----- old working logic re-implemented | TODO: check logic and reduce
    if (searchTerm.length > 1) {
      if (searchTerm.length == 2) {
        if (searchTerm[0] === '' && searchTerm[1] === '') {
          others = searchTerm.join(' ');
          fetchFilter = encodeURI(
            `(eventid=${session.eventid})AND((email CONTAINS ${others})OR(company CONTAINS ${others})OR(position CONTAINS ${others}))`
          );
        } else {
          others = searchTerm.join(' ');
          fetchFilter = encodeURI(
            `(eventid=${session.eventid})AND((firstname=${searchTerm[0]})OR(firstname CONTAINS ${others})OR(lastname=${searchTerm[1]})OR(email CONTAINS ${others})OR(company CONTAINS ${others})OR(position CONTAINS ${others}))`
          );
        }
      } else if (searchTerm.length == 3) {
        others = searchTerm.join(' ');
        let fname = `${searchTerm[0]} ${searchTerm[1]}`;
        let lname = `${searchTerm[2]}`;
        fetchFilter = encodeURI(
          `(eventid=${session.eventid})AND((firstname=${fname})OR(lastname=${lname})OR(email CONTAINS ${others})OR(company CONTAINS ${others})OR(position CONTAINS ${others}))`
        );
      } else if (searchTerm.length > 3) {
        others = searchTerm.join(' ');
        fetchFilter = encodeURI(
          `(eventid=${session.eventid})AND((email CONTAINS ${others})OR(company CONTAINS ${others})OR(position CONTAINS ${others}))`
        );
      }
    } else {
      let keywords = searchTerm[0];
      if (typeof searchTerm === 'string') {
        keywords = searchTerm;
      }

      fetchFilter = encodeURI(
        `(eventid=${session.eventid})AND((firstname CONTAINS ${keywords})OR(lastname CONTAINS ${keywords})OR(email CONTAINS ${keywords})OR(company CONTAINS ${keywords})OR(position CONTAINS ${keywords}))`
      );
    }
  } else fetchFilter = encodeURI(`eventid=${session.eventid}`);
  let eventFilter = encodeURI(
    `(eventid=${session.eventid})AND(apptabid=${middleWares.scheduleApptabId})`
  );

  let speakerRelated = !_.isNull(selectedSpeakerId)
    ? '&related=session_by_sessionspeakers'
    : '';
  let speakerFields = _.isNull(selectedSpeakerId)
    ? `&fields=${FIELDS.speaker.mediumInfo}`
    : '';
  let speakerOrderby = `${middleWares?.featured ? 'featured,' : ''}${
    _.isEqual(middleWares?.sort, 'az')
      ? FETCH_ORDERS.speaker.name
      : FETCH_ORDERS.speaker.random
  }`;
  let sessionOrderby = FETCH_ORDERS.session;

  let speakerUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.speaker}?include_count=true${speakerRelated}${speakerFields}&filter=(${fetchFilter})&order=${speakerOrderby}${offSetQuery}`;
  let sessionUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?include_count=true&filter=(${eventFilter})&order=${sessionOrderby}`;

  return dispatch => {
    getRequest(
      speakerUrl,
      session,
      dispatch,
      speakerRes => {
        let responseArr = speakerRes.resource;

        // --- name and name initial handling
        _.map(responseArr, speaker => {
          let firstName = !_.isEmpty(speaker?.firstname)
            ? speaker?.firstname.trim()
            : 'G';
          let lastName = !_.isEmpty(speaker?.lastname)
            ? speaker?.lastname.trim()
            : 'U';

          speaker.firstname = firstName;
          speaker.lastname = lastName;
        });

        // --- session wise filter and assigning to speaker payload
        if (!_.isNull(selectedSpeakerId)) {
          getRequest(
            sessionUrl,
            session,
            dispatch,
            sessionRes => {
              let sessions_arr = sessionRes.resource;
              let filterArr = [];

              _.map(responseArr, (speaker, idx) => {
                filterArr = _.filter(sessions_arr, item => {
                  return item.speakerid == speaker.speakerid;
                });

                speaker.session_by_sessionspeakers = _.concat(
                  speaker?.session_by_sessionspeakers,
                  filterArr
                );
              });
            },
            error => {}
          );
        }

        // --- bookmark handling
        _.map(responseArr, (speakerItem, resourceIndex) => {
          let itemObj = speakerItem;

          // - if coming for rerender with selected item id setting key bool value acc. to action
          if (
            selectedSpeakerId &&
            speakerItem.speakerid == selectedSpeakerId &&
            (bookmarkAction != '' || bookmarkAction != 'rerender')
          )
            itemObj.isBookMarked = bookmarkAction == 'unmark' ? false : true;
          else itemObj.isBookMarked = false;

          responseArr[resourceIndex] = itemObj;
        });

        // --- redirection actionType section
        if (actionType == 'redirection' && selectedSpeakerId) {
          let filterSpkr = _.filter(
            responseArr,
            spkr => spkr.speakerid == selectedSpeakerId
          );
          if (filterSpkr.length)
            dispatch(
              openSpeakerDetails(
                session,
                {
                  show: true,
                  value: filterSpkr[0],
                  calledFrom: 'map-details'
                },
                { scheduleApptabId: middleWares.scheduleApptabId }
              )
            );
        }

        // --- payload creation and dispatches
        let payloadObj = {
          count: speakerRes.meta.count
        };
        if (reRender) {
          chunkDataArr[pageCount == 0 ? 0 : pageCount - 1] = responseArr;
          payloadObj.data = _.flatten(chunkDataArr);
        } else payloadObj.data = dataArr.concat(responseArr);

        dispatch({
          type: FETCH_SPEAKERS,
          payload: payloadObj
        });
        callback({
          ...payloadObj,
          success: 1
        });
      },
      error => {
        callback({
          success: 0,
          message: error
        });
      }
    );
  };
};

// ----- redux value clear
export const clearBookedSpeakers = () => {
  return dispatch => {
    dispatch({
      type: MY_BOOKED_SPEAKERS,
      payload: {}
    });
  };
};

export const clearSpeakers = () => {
  return dispatch => {
    dispatch({ type: FETCH_SPEAKERS, payload: [] });
  };
};

export const openSpeakerDetails = (
  session = null,
  actVal,
  extra = { scheduleApptabId: null }
) => {
  if (actVal.show && !_.isEmpty(actVal.value)) {
    return dispatch => {
      dispatch({ type: OPEN_SPEAKER_DETAILS, payload: actVal });
      dispatch(
        fetchSpeakerSessions(
          session,
          {
            speakerid: actVal.value?.speakerid,
            scheduleApptabId: extra.scheduleApptabId
          },
          res => {
            if (res.success) {
              let obj = res.data;
              actVal.value = obj;
              dispatch({ type: OPEN_SPEAKER_DETAILS, payload: actVal });
              callback && callback({ success: 1 });
            }
          }
        )
      );
    };
  } else {
    return dispatch => {
      dispatch({ type: OPEN_SPEAKER_DETAILS, payload: actVal });
    };
  }
};

export const showBackSpeakerScreen = value => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
};

export const fetchSpeakerSessions = (
  session,
  extra = { speakerid: null, scheduleApptabId: null },
  callback
) => {
  let speakerFilter = encodeURI(
    `(eventid=${session.eventid})AND(speakerid=${extra.speakerid})`
  );
  let sessionFilter = encodeURI(
    `(eventid=${session.eventid})AND(apptabid=${extra.scheduleApptabId})`
  );
  let related = `session_by_sessionspeakers&session_by_sessionspeakers.fields=${FIELDS.session.mediumInfo}`;
  let orderby = FETCH_ORDERS.session;
  let speakerUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.speaker}?related=${related}&filter=(${speakerFilter})`;
  let sessionUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?include_count=true&filter=(${sessionFilter})&order=${orderby}`;

  return dispatch => {
    getRequest(
      speakerUrl,
      session,
      dispatch,
      response => {
        let speaker = response.resource[0];

        let firstName = !_.isEmpty(speaker?.firstname)
          ? speaker?.firstname.trim()
          : 'G';
        let lastName = !_.isEmpty(speaker?.lastname)
          ? speaker?.lastname.trim()
          : 'U';

        speaker.firstname = firstName;
        speaker.lastname = lastName;

        callback({
          success: 1,
          data: speaker
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSpeakerAssociatedUser = (
  session,
  extra = { speakerId: null },
  callback
) => {
  if (_.isNil(extra?.speakerId)) return dispatch => {};

  const fetchFilter = encodeURI(
    `(eventid=${session.eventid})AND(speakeridfk=${extra?.speakerId})AND(isnetworking=1)`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}?fields=${FIELDS.appuser.relatedInfo}&filter=(${fetchFilter})`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res?.resource?.[0], error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};
